module.exports = __webpack_public_path__ + "img/aboutPage_service_icon66.616e1e1e.png";